import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Panel } from "@/components/shared";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import DigestPreview from "@/components/DigestPreview";

export default function EmailPrefs() {
  const [d, setD] = useState(null);
  const { user } = useAuth();
  useEffect(() => { api.get("/email/preferences").then((r) => setD(r.data)); }, []);
  const toggle = async (key, enabled) => {
    try { const { data } = await api.put("/email/preferences", { prefs: { [key]: enabled } }); setD(data); toast.success(enabled ? "Emails turned on" : "Emails turned off"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!d) return null;
  return (
    <Panel testid="privacy-email-prefs">
      <h2 className="text-lg font-semibold">Email notifications</h2>
      <p className="mt-1 text-sm text-muted-foreground">Choose which alerts reach your inbox. Every alert email also has a one-click unsubscribe link.</p>
      <div className="mt-4 space-y-3">
        {d.items.map((i) => (
          <label key={i.key} className="flex items-center justify-between gap-4 text-sm font-medium">
            {i.label}<Switch checked={i.enabled} onCheckedChange={(v) => toggle(i.key, v)} data-testid={`email-pref-${i.key}`} />
          </label>
        ))}
      </div>
      {user.role !== "recruiter" && <DigestPreview />}
      <p className="mt-4 text-xs text-muted-foreground">Always sent for your security: {d.always_sent.join(", ")}.</p>
    </Panel>
  );
}
